module.exports = __webpack_public_path__ + "img/search.c6778577.svg";